import * as React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Box } from '@mui/system';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import { Link } from 'react-router-dom';
// import { Chip } from '@mui/material';
// import { Person } from '@mui/icons-material';

function handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
  event.preventDefault();
}

export default function Breadcrumb({ PermitName, PageTitle }) {
  const currentPermitDetails = useSelector(
    (store: RootState) => store.currentPermit.currentPermitDetails
  );

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%'
      }}
    >
      <Box
        mb={{ xs: 1, sm: 2 }}
        role="presentation"
        onClick={handleClick}
        p={1}
        sx={{
          backgroundColor: '#ffffff',
          borderRadius: '10px 0 0 10px',
          boxShadow:
            'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px',
          display: 'inline-block'
        }}
        className="breadcrumbWrapper"
      >
        <Breadcrumbs aria-label="breadcrumb" className="breadcrumb_inner">
          <Link
            style={{ color: '#223354' }}
            to={`/dashboard/${currentPermitDetails.townshipId}`}
          >
            Dashboard
          </Link>
          <Link
            style={{ color: '#223354' }}
            to={`/${currentPermitDetails.townshipId}/${currentPermitDetails.departmentName}/${currentPermitDetails.id}/application-list`}
          >
            {PermitName}
          </Link>
          <Typography sx={{ color: '#223354' }}>{PageTitle}</Typography>
        </Breadcrumbs>
      </Box>
      {/* <Chip
        icon={<Person />}
        label={currentPermitDetails?.currentPermitUserRole}
        color="primary"
      /> */}
    </Box>
  );
}
